import $ = require('jquery');
import Modul from './Modul';

/**
 * Download document module
 *
 */
export default class ModulDownloadDocument extends Modul {
    private $uploadField: JQuery;
    private $linkTargetCheckbox: JQuery;
    private $form: JQuery;

    constructor(moduleId: number) {
        super(moduleId);

        this.$uploadField = $('#upload_wrapper_' + moduleId);
        this.$linkTargetCheckbox = $('#download_target_check_' + moduleId);

        /* get the form and add DIY form to it */
        this.$form = this.$uploadField.closest('form');
        this.$form.diy_form();

        this.$uploadField.diy_uploadField({
            change: function() {
                $(this).closest('form').submit();
            }
        });

        this.$linkTargetCheckbox.diy_checkbox();
    }

    uploadError(errMsg: string) {
        this.$form.diy_form("addError", errMsg, this.$uploadField);
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulDownloadDocument.ts
 **/